import { type AxiosInstance } from 'axios'
import { CancelablePromise, type OpenAPIConfig } from '../generated/mobileAuthApi'
import { AxiosHttpRequest } from '../generated/mobileAuthApi/core/AxiosHttpRequest'
import type { ApiRequestOptions } from '../generated/mobileAuthApi/core/ApiRequestOptions'
import { request } from '../generated/mobileAuthApi/core/request'

// Wrapper over AxiosHttpRequest (used by generated API client by default)
// which uses custom axios instance and configures auth interceptor.
// NOTE: this class imports from `generated/mobileAuthApi`.
export function buildCustomAxiosHttpRequestMobileAuth(axiosInstance: AxiosInstance) {
  return class HttpRequestCustomAxiosMobileAuth extends AxiosHttpRequest {
    axiosInstance: AxiosInstance

    constructor(config: OpenAPIConfig) {
      super(config)

      this.axiosInstance = axiosInstance
    }

    public request<T>(options: ApiRequestOptions): CancelablePromise<T> {
      return request<T>(this.config, options, this.axiosInstance)
    }
  }
}
